import Footer from "./Footer/Footer";
import { useNavigate } from "react-router-dom";

const MaintenancePage = () => {
    const navigate = useNavigate();

    return (
        <>
            <div style={styles.wrapper}>
                <div style={styles.container}>

                    <div style={styles.iconCircle}>
                        <svg
                            width="28"
                            height="28"
                            viewBox="0 0 24 24"
                            fill="none"
                            stroke="#64748b"
                            strokeWidth="1.8"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                        >
                            <circle cx="12" cy="12" r="3" />
                            <path d="M19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 
              2 0 1 1-2.83 2.83l-.06-.06a1.65 
              1.65 0 0 0-1.82-.33 1.65 
              1.65 0 0 0-1 1.51V21a2 
              2 0 1 1-4 0v-.09a1.65 
              1.65 0 0 0-1-1.51 1.65 
              1.65 0 0 0-1.82.33l-.06.06a2 
              2 0 1 1-2.83-2.83l.06-.06a1.65 
              1.65 0 0 0 .33-1.82 1.65 
              1.65 0 0 0-1.51-1H3a2 
              2 0 1 1 0-4h.09c.7 0 
              1.31-.4 1.51-1a1.65 
              1.65 0 0 0-.33-1.82l-.06-.06a2 
              2 0 1 1 2.83-2.83l.06.06c.47.47 
              1.15.61 1.82.33h.01c.6-.2 
              1-.81 1-1.51V3a2 
              2 0 1 1 4 0v.09c0 .7.4 
              1.31 1 1.51.67.28 1.35.14 
              1.82-.33l.06-.06a2 
              2 0 1 1 2.83 2.83l-.06.06c-.47.47-.61 
              1.15-.33 1.82v.01c.2.6.81 
              1 1.51 1H21a2 
              2 0 1 1 0 4h-.09c-.7 
              0-1.31.4-1.51 1z" />
                        </svg>
                    </div>

                    <div style={styles.label}>SCHEDULED MAINTENANCE</div>

                    <div style={styles.title}>We’ll Be Right</div>
                    <div style={styles.subtitle}>Back with You</div>

                    <p style={styles.text}>
                        Our systems are currently undergoing scheduled maintenance to improve your experience. We apologize for any inconvenience and appreciate your patience.
                    </p>

                    <div style={styles.infoCard}>
                        <strong>Estimated restoration</strong>
                        <br />
                        8:00 AM EST — Next Business Day
                    </div>

                    <div style={styles.footer}>
                        If you require immediate assistance, please contact our support team at
                        support@glueid.com
                    </div>

                    <button
                        style={styles.button}
                        onClick={() => navigate("/")}
                    >
                        Go Back Home
                    </button>

                </div>
            </div>
            <Footer />
        </>
    );
};

const styles = {
    wrapper: {
        height: "90vh",
        background: "#f1f5f9",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        fontFamily: "'Inter', Arial, sans-serif",
    },
    container: {
        textAlign: "center",
        maxWidth: "520px",
    },
    iconCircle: {
        width: "70px",
        height: "70px",
        borderRadius: "50%",
        background: "#e2e8f0",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        margin: "0 auto 20px auto",
    },
    label: {
        fontSize: "15px",
        letterSpacing: "2px",
        color: "#94a3b8",
        marginBottom: "20px",
        fontWeight: '600',
    },
    title: {
        fontSize: "34px",
        fontWeight: "500",
        color: "#1e293b",
        marginBottom: "5px",
    },
    subtitle: {
        fontSize: "28px",
        fontStyle: "italic",
        color: "#334155",
        marginBottom: "20px",
    },
    text: {
        fontSize: "16px",
        color: "#64748b",
        lineHeight: "1.6",
        marginBottom: "30px",
    },
    infoCard: {
        background: "#ffffff",
        border: "1px solid #e2e8f0",
        borderRadius: "10px",
        padding: "15px 20px",
        display: "inline-block",
        fontSize: "15px",
        color: "#334155",
        marginBottom: "25px",
    },
    footer: {
        fontSize: "15px",
    },
    button: {
        marginTop:'50px',
        padding: "10px 18px",
        borderRadius: "6px",
        border: "1px solid #cbd5f5",
        background: "#ffffff",
        color: "#2A3C7B",
        cursor: "pointer",
        fontWeight: "500",
    },
};

export default MaintenancePage;